import React from 'react';
import { connect } from 'react-redux';
import PortfolioList from '../components/PortfolioList';
import Filter from '../components/Filter';
import { history } from '../../routes';

const { array } = React.PropTypes;

const PortfolioContainer = React.createClass({
  propTypes: {
    data: array.isRequired
  },


  getInitialState() {
    const keys = Object.keys(this.props.location.query);
    const selected = (keys.length > 0) ? keys[0] : 'default';

    return {
      selected: selected,
      data: this.filterData(selected)
    }
  },


  componentWillReceiveProps(newProps) {
    const keys = Object.keys(newProps.location.query);
    const selected = (keys.length > 0) ? keys[0] : 'default';

    this.setState({
      selected: selected,
      data: this.filterData(selected)
    });
  },


  componentDidMount() {
    const body = document.getElementsByTagName('body')[0];
    body.className = 'archive';

    window.scrollTo(0,0);
    document.title = 'Nathan Kleekamp | Portfolio';
    this.setMetaDescription();
  },


  setMetaDescription() {
    const desc = document.querySelectorAll('meta[name=description');
    desc[0].content = "A growing list of past projects.";
  },


  /*
   * Loop through the data, get filter_type, then reduce the resulting
   * array to unique entries.
   */

  getChoices() {
    return this.props.data.map(item => {
      return item.filter_type;
    }).reduce((a, b) => {
      return (a.indexOf(b) === -1) ? a.concat(b) : a;
    }, []);
  },


  filterData(selection) {
    const data = this.props.data.slice();

    if (selection === 'default') {
      return data;
    }

    return data.filter(item => {
      return item.filter_type.toLowerCase() === selection.toLowerCase();
    });
  },


  handleSelectChange(e) {
    const data = this.props.data;
    const selected = e.target.value;

    history.push(`portfolio?${selected}`);

    this.setState({
      selected: selected,
      data: this.filterData(selected)
    });
  },


  render() {
    const props = this.props;

    return (
      <div>
        <h2 className="center-text">Portfolio.</h2>
        <Filter choices={ this.getChoices() } selected={ this.state.selected } onChange={ this.handleSelectChange } />
        <PortfolioList data={ this.state.data } rows={ true } />
      </div>
    );
  }
});




const mapStateToProps = ({ app }) => {
  const data = app.data;

  return {
    data
  };
};

export default connect(mapStateToProps)(PortfolioContainer);




// WEBPACK FOOTER //
// ./app/src/Portfolio/containers/PortfolioContainer.js